<template>
  <div class="about">
    <div class="about-content-wrapper">
      <h1>About Me</h1>
      <p>{{ about.description }}</p>
      <div class="about-content">
        <div class="skills">
          <h2>Skills</h2>
          <div v-for="skill in about.skills" :key="skill.id" class="skill-item">
            <strong v-if="(skill.title)">{{ skill.title }}: {{ skill.icon }}</strong>
            <div v-if="(!skill.caption)" class="details">
              <span>level: <small>{{ skill.level }} with {{  skill.experience }}</small></span>
            </div>
            <div v-else class="skill-caption">
              <small>{{ skill.caption }}</small>
            </div>
          </div>
        </div>
        
        <div class="qualification">
          <h2>Qualifications</h2>
          <div v-for="qualification in about.qualifications" :key="qualification.title" class="qualification-item">
            <strong>{{ qualification.cert }}</strong>
            <div class="details">
              <span>Studied at {{ qualification.institution }} </span>
              <span><small>- {{ qualification.year }}</small></span>
            </div>
          </div>
        </div>
      </div>
      <div class="experience">
        <h2>Web Dev Experience</h2>
        <div v-for="experience in about.experience" :key="experience.company" class="experience-item">
          <strong>{{ experience.role }}</strong> at {{ experience.company }}
          <div class="details">
            <span><small>({{ experience.duration }})</small></span>
            <span>{{ experience.details }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue'
import ABOUT from '../data/aboutDB.js'

export default {
  name: 'AboutView',
  components: {
  },
  setup() {
    const about = ref(ABOUT)

    return {
      about
    }
  }
}
</script>

<style scoped lang="scss">
.about {
  display: flex;
  width: 75%;
  gap: 40px;
  padding: 50px;
  flex-direction: column;
  margin: auto;

  @include breakpoint(xl_1) {
    margin: 100px auto 0;
  }

  @include breakpoint(sm_2) {
    width: 90%;
    // margin: 85px auto 0;
  }
}
.about-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  width: 100%;

  h2{
    text-align: left;
    text-decoration: underline;
  }

  @include breakpoint(xl_1) {
    grid-template-columns: 1fr;
  }
}

.skills, .qualification {
  text-align: left;
}

.skill-item, .qualification-item {
  margin-bottom: 15px;
}

.qualification-item .details {
  display: flex;
  justify-content: space-between;
}

.experience {
  width: 100%;
  margin-top: 50px;
  text-align: left;

  .details {
    display: flex;
    flex-direction: column;
  }
}

.experience-item {
  margin-bottom: 15px;
}

.skill-caption {
  border-top: 1px solid #ccc;
  margin-top: 5px;
  padding-top: 5px;
}
</style>